import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { DataProductService } from 'src/app/shared/services/API/data-mesh/data-product.service';
import { DataSetService } from 'src/app/shared/services/API/data-mesh/datasets.service';
import { Masks } from 'src/app/shared/services/mask.service';
import { DataProductModel } from 'src/app/shared/services/models/data-mesh/data-product.model';
import { DataSetModel } from 'src/app/shared/services/models/data-mesh/data-set.model';
import { ListProfileStruct } from 'src/app/shared/services/structs/admin-user/list-profile.struct';

@Component({
  selector: 'app-data-set-list',
  templateUrl: './data-set-list.component.html',
  styleUrls: ['./data-set-list.component.css']
})
export class DataSetListComponent implements OnInit {
  constructor(
    private alertService: AlertService,
    private dataProductService: DataSetService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog) { }
  public menuModuleEnum: MenuModuleEnum = MenuModuleEnum.datamesh;
  public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.datamesh_data_sets;

  public model: FormGroup;
  public isLoading: boolean;
  public isFirstLoading: boolean;
  public isUpdate: boolean;
  public searchText: string;
  public listDataset: DataSetModel[] = [];
  public listProfile: ListProfileStruct[] = [];
  public masks: Masks;

  ngOnInit(): void {
    this.populateScreen();    
    this.searchText = null;
  }

  populateScreen() {
    this.search();
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search();
      }
    }, 1000);
  }

  search() {
    if (this.searchText == "")
      this.searchText = null;

    this.isLoading = true;
    this.dataProductService.getAllDataSets().subscribe((response) => {

      if (response.isError) {
        this.alertService.show('Error', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }

      this.listDataset = response.dataSets;
      this.isLoading = false;
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Unexpected Error', error, AlertType.error);
      });
  }

  deleteDataSet(idDataProduct: number) {
    this.isLoading = true;
    this.dataProductService.deleteDataSet(idDataProduct).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.search();
        this.alertService.show('Sucesso!', 'Produto excluído com sucesso', AlertType.success);
      },
      error: (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }
}

